import { hubConnection } from 'signalr-no-jquery'
import auth from '@it-enterprise/jwtauthentication/dist/jwtauthentication.umd.min.js'
import { signalRCoreConnect } from './signalRCoreConnect'
import store from '../../store'

const connections = {}

export const signalRApi = {
  subscribe(type, onReceive) {
    // защита от повторного подключения
    if (connections[type] != undefined) {
      return
    }

    const url = store.state.general.config.SignalRUrl
    if (!url) {
      console.warn('signalr url not configured')
      return
    }
    const hubName = 'messagehub'
    const connection = connections[type] = hubConnection(url, {
      logging: true,
      useDefaultPath: false
    })
    //const appName = 'SMARTMANAGER'
    const token = auth._getRefreshToken()
    const hubProxy = connection.createHubProxy(hubName)
     
    hubProxy.on('receiveMessage', onReceive)

    const subscribeFunc = () => {
      const args = [type, token]
      connection.send({ H: hubName, M: 'Subscribe', A: args, I: 0 })
    }
    
    connection.reconnected(subscribeFunc)
    connection.error((e) => {
      if (e?.message.startsWith('The client has been inactive since')) {
        signalRApi.unsubscribe(type) 
        signalRApi.subscribe(type, onReceive)
      }
    })

    function connectionStart() {
      connection.start({ withCredentials: false })
        .done(subscribeFunc)
        .fail(() => {
          console.error('Old SignalR not connected')
          connections[type] = signalRCoreConnect(type, url, onReceive, token)
        })
    }
    connectionStart()
  },

  unsubscribe(type) {
    if (!connections[type]) {
      return
    }  
    if (connections[type].closedCallbacks) {
      connections[type].closedCallbacks = []
    }
    if (connections[type].stop) {
      connections[type].stop()
    }
    delete connections[type]
  }

}